export default "__VITE_ASSET__43496c42__"